import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-blog-grid',
  templateUrl: './page-blog-grid.component.html',
  styleUrls: ['./page-blog-grid.component.css'],
  standalone: false,
})
export class PageBlogGridComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
